const ShopBackComponent = () => import('@/views/shop/ShopBack/ShopBackView')

export default [
    {
        path:'/ShopBackIndex',
        name:'ShopBackRouter',
        component:ShopBackComponent
    }
]